import Icon from '@/modules/components/Icon'
import aicpaSoc from '@/modules/images/footer/certificates/Aicpa-square.png'
import bsi from '@/modules/images/footer/certificates/BSI.png'
import CSA from '@/modules/images/footer/certificates/CSA_Cyber_Trust_Logo.png'
import isoIec from '@/modules/images/footer/certificates/ISO-IEC-27001.png'
import pci from '@/modules/images/footer/certificates/PCI-CSS-CERTIFIED.png'
import sgs from '@/modules/images/footer/certificates/SGS.png'

import type { Certificate, Social } from './types'

export const certificates: Certificate[] = [
  {
    src: aicpaSoc,
    width: [51, 53],
    margin: [1],
  },
  {
    src: sgs,
    width: [53, 61],
    margin: [1],
  },
  {
    src: isoIec,
    width: [109, 56],
    margin: [1],
  },
  {
    src: pci,
    width: [58, 90],
    margin: [1],
    marginRight: ['0px', '25px'],
  },
  {
    src: bsi,
    width: [78],
    margin: [0],
    opacity: 0.5,
  },
  {
    src: CSA,
    width: [91],
    margin: [2],
    opacity: 0.5,
  },
]

export const socials: Social[] = [
  {
    IconComponent: Icon.Twitter,
    href: 'https://twitter.com/cryptocom',
  },
  {
    IconComponent: Icon.Facebook,
    href: 'https://www.facebook.com/CryptoComOfficial',
  },
  {
    IconComponent: Icon.Instagram,
    href: 'https://www.instagram.com/cryptocomofficial/',
  },
  {
    IconComponent: Icon.LinkedIn,
    href: 'https://hk.linkedin.com/company/cryptocom',
  },
  {
    IconComponent: Icon.Youtube,
    href: 'https://www.youtube.com/channel/UCOMprzxakZOqmY23LYIawmg',
  },
  {
    IconComponent: Icon.Reddit,
    href: 'https://www.reddit.com/r/Crypto_com/',
  },
  {
    IconComponent: Icon.Discord,
    href: 'https://discord.gg/cryptocom',
  },
  {
    IconComponent: Icon.Telegram,
    href: 'https://blog.crypto.com/official-crypto-com-telegram-communities/',
  },
  {
    IconComponent: Icon.KakaoTalk,
    href: 'https://open.kakao.com/o/gGH1WQM',
  },
]
